import _ from "lodash"
import React from "react"
import PropTypes from "prop-types"
import { List } from "immutable"
import { connect } from "react-redux"
import { Tabs, Button } from "antd"
import TabContent from "./TabContent"
import * as actions from "../redux/actions"

const { TabPane } = Tabs

class ContentView extends React.Component {
	static propTypes = {
		data: PropTypes.objectOf(List),
		currentTabRegNo: PropTypes.string,
		tabChange: PropTypes.func,
		showSoEditModal: PropTypes.func,
		deleteRegNo: PropTypes.func,
		showSoModal: PropTypes.func,
	}

	_renderTabPanes = (regNos) => {
		return _.map(regNos, (regNo, index) => {
			return (
				<TabPane tab={regNo} key={index}>
					<TabContent regNo={regNo} />
				</TabPane>
			)
		})
	}

	_renderExtraContent = () => {
		return (
			(
				<div>
					<Button
						icon="edit"
						style={{ marginLeft: 24 }}
						onClick={() => {
							this.props.showSoEditModal()
						}}
					>
						編輯
					</Button>
					<Button
						icon="delete"
						type="danger"
						style={{ marginLeft: 24 }}
						onClick={() => {
							this.props.deleteRegNo()
						}}
					>
						刪除
					</Button>
				</div>
			)
		)
	}

	render() {
		const data = this.props.data.toJS()
		const regNos = _.keys(data)

		// 若已經有 regNo 但還沒有設定目前的 regNo 先設定一下
		if (regNos.length > 0 && !this.props.currentTabRegNo) {
			this.props.tabChange(regNos[0])
		}

		if (regNos.length === 0) {
			return (
				<div style={{ display: "flex", flex: 1, flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
					<p>目前沒有資料</p>
					<Button
						type="primary"
						icon="plus"
						style={{ margin: 8 }}
						onClick={this.props.showSoModal}
					>
						新增
					</Button>
				</div>
			)
		} else {
			return (
				<Tabs
					defaultActiveKey="0"
					tabBarExtraContent={this._renderExtraContent()}
					onChange={(key) => {
						this.props.tabChange(regNos[key])
					}}
				>
					{this._renderTabPanes(regNos)}
				</Tabs>
			)
		}
	}
}

const mapStateToProps = (state) => {
	return {
		data: state.getIn(["main", "data"]),
		currentTabRegNo: state.getIn(["main", "currentTabRegNo"]),
	}
}

const mapDispatchToProps = {
	tabChange: actions.tabChange,
	showSoEditModal: actions.showSoEditModal,
	deleteRegNo: actions.deleteRegNo,
	showSoModal: actions.showSoModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentView)



// WEBPACK FOOTER //
// ./src/conponents/ContentView.js